/**
 * Контент баннера премии по датам события.
 * Аналог `www/vue_components/common/AwardBanner/constants`.
 */
export const AWARD_BANNER_COOKIE = 'award_banner'

/** Время жизни cookie после «Скрыть» (полдня). */
export const AWARD_BANNER_COOKIE_TTL_DAYS = 0.5

const EVENT_YEAR = 2025

export const AWARD_EVENT_DATES = [
  new Date(EVENT_YEAR, 9, 1, 0, 0, 0),
  new Date(EVENT_YEAR, 10, 5, 0, 0, 0),
  new Date(EVENT_YEAR, 10, 11, 0, 0, 0),
  new Date(EVENT_YEAR, 10, 21, 0, 0, 0),
  new Date(EVENT_YEAR, 10, 22, 0, 0, 0),
  new Date(EVENT_YEAR, 10, 22, 17, 0, 0),
  new Date(EVENT_YEAR, 10, 23, 0, 0, 0),
]

export const AWARD_CONTENT_BY_DATE = [
  {
    isDarkMode: false,
    banner: {
      title: `Всероссийская премия ПроДокторов ${EVENT_YEAR}`,
      button: {
        moreText: 'Подробнее',
        moreLink: 'https://pd.tc/p1cGWKoo',
      },
    },
  },
  {
    isDarkMode: false,
    banner: {
      title: `Результаты премии ПроДокторов ${EVENT_YEAR}`,
      button: {
        moreText: 'Подробнее',
        moreLink: 'https://pd.tc/jfcBXfPB',
      },
    },
  },
  {
    isDarkMode: true,
    banner: {
      title: `Гран-при премии ПроДокторов ${EVENT_YEAR} пройдёт 22 ноября`,
      button: {
        moreText: 'Подробнее',
        moreLink: 'https://pd.tc/6vhfniAe',
      },
    },
  },
  {
    isDarkMode: true,
    banner: {
      title: `Гран-при премии ПроДокторов ${EVENT_YEAR}. Начало трансляции завтра в 17:00 (мск)`,
      button: {
        moreText: 'Подробнее',
        moreLink: 'https://pd.tc/6vhfniAe',
      },
    },
  },
  {
    isDarkMode: true,
    banner: {
      title: `Скоро трансляция Гран-при премии ПроДокторов ${EVENT_YEAR}. Начало трансляции в 17:00 (мск)`,
      button: {
        moreText: 'Подробнее',
        moreLink: 'https://pd.tc/6vhfniAe',
      },
    },
  },
  {
    isDarkMode: true,
    banner: {
      title: `Смотреть трансляцию Гран-при премии ПроДокторов ${EVENT_YEAR}`,
      button: {
        moreText: 'Смотреть',
        moreLink: 'https://vkvideo.ru/video-120057026_456239641',
      },
    },
  },
  {
    isDarkMode: true,
    banner: {
      title: `Результаты  Гран-при премии ПроДокторов ${EVENT_YEAR}`,
      button: {
        moreText: 'Подробнее',
        moreLink: 'https://pd.tc/6vhfniAe',
      },
    },
  },
] as const

/** Окно показа баннера. */
export const AWARD_BANNER_VISIBLE_FROM = new Date(2025, 8, 29, 0, 0, 0)
export const AWARD_BANNER_VISIBLE_UNTIL = new Date(2025, 10, 31, 0, 0, 0)
